import { render, staticRenderFns } from "./commonTitle.vue?vue&type=template&id=c235bb7c&scoped=true&"
import script from "./commonTitle.vue?vue&type=script&lang=js&"
export * from "./commonTitle.vue?vue&type=script&lang=js&"
import style0 from "./commonTitle.vue?vue&type=style&index=0&id=c235bb7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c235bb7c",
  null
  
)

export default component.exports